import { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { Modal } from 'bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { errorCss } from '../Utils/formik-util';
import { Dropdown } from 'primereact/dropdown';
import { comparer } from '../../utils/comparer'
import { useToast } from '../../toastHook'
import { ConfirmModalComponent } from '../Utils/ConfirmModal'


export const ActiviteVersCompetenceAvecPrioriteComponent = ({ controllerNaming , textNaming, infoDiv   }) => {

    const { display } = useToast();
    const [openConfirmRemoveModal, setOpenConfirmRemoveModal] = useState(false);

    const [rows, setRows] = useState([]);
    const [competences, setCompetences] = useState([]);
    const [nbModifs, setNbModifs] = useState(0);

    const modalRefInsert = useRef();
    const modalRefUpdate = useRef();
    const [activiteToInsert, setActiviteToInsert] = useState('');

    const [toRemoveActivite, setToRemoveActivite] = useState('');
    const [toRemoveCompetence, setToRemoveCompetence] = useState('');

    const [activiteToUpdate, setActiviteToUpdate] = useState('');
    const [competenceToUpdate, setCompetenceToUpdate] = useState('');

    const insertFormValidationSchema = Yup.object().shape({
        competence: Yup.string()
            .required('Requis')
            .oneOf(competences.map(x => x.value),'compétence incorrecte'),
        priorite: Yup.number().integer().min(0, 'doit être supérieur à 0').max(100, 'doit être inférieur à 100').required('Requis')
    });

    const updateFormValidationSchema = Yup.object().shape({
        priorite: Yup.number().integer().min(0, 'doit être supérieur à 0').max(100, 'doit être inférieur à 100').required('Requis')
    })

    const insertFormik = useFormik({
        initialValues: {
            competence: '',
            priorite: ''
        },
        validationSchema: insertFormValidationSchema,
        onSubmit: values => {

            const activite = activiteToInsert;
            axios.post('/api/competence' + controllerNaming + '/add', {
                competence: values.competence,
                priorite: values.priorite,
                activite: activite
            }).then(response => {
                if (response.status === 200) {

                    display({
                        titre: `compétence ${textNaming} ajouté`,
                        text: `la compétence ${textNaming} '${values.competence}' a été ajouté à l'activité' ${activite}`,
                        severity: 'success'
                    });

                    setNbModifs(nbModifs + 1);
                }
                else {
                    display({
                        titre: `compétence ${textNaming} non ajouté`,
                        text: `la compétence ${textNaming} '${values.competence}' n'a pas pu être ajouté à l'activité' ${activite}`,
                        severity: 'danger'
                    })
                }
            });


            const modal = Modal.getOrCreateInstance(modalRefInsert.current);
            modal.hide();
        }
    });

    const updateFormik = useFormik({
        initialValues: {
            priorite: ''
        },
        validationSchema: updateFormValidationSchema,
        onSubmit: values => {

            axios.post('/api/competence'+ controllerNaming +  '/update', {
                competence: competenceToUpdate,
                priorite: values.priorite,
                activite: activiteToUpdate
            }).then(response => {
                if (response.status == 200) {

                    display({
                        titre: `compétence ${textNaming} ajouté`,
                        text: `la compétence ${ textNaming } '${competenceToUpdate}' de l'activité' ${activiteToUpdate} a maintenant une priorité ${values.priorite}`,
                        severity: 'success'
                    });

                    setNbModifs(nbModifs + 1);
                }
                else {
                    display({
                        titre: `compétence ${textNaming} non ajouté`,
                        text: `la propriété de la compétence ${textNaming} '${competenceToUpdate}' de l'activité' ${activiteToUpdate} n'a pas pu être modifiée'`,
                        severity: 'danger'
                    })
                }
            });

            const modal = Modal.getOrCreateInstance(modalRefUpdate.current);
            modal.hide();
        }
    });

    useEffect(() => {
        axios.get('/api/competence'+  controllerNaming  + '/get')
            .then(response => {
                if (response.data) {

                    let tmpRows = [];

                    for (const key in response.data) {
                        const values = response.data[key];

                        const tmpValues = values.map(x => {
                            return {
                                key: key + '-' + x.competence,
                                data: {
                                    activite: key,
                                    competence: x.competence,
                                    priorite: x.priorite
                                }
                            }
                        })

                        tmpValues.sort((x,y) => comparer(x.data.competence, y.data.competence))

                        tmpRows.push({
                            key: key,
                            data: {
                                activite: key,
                                competence: '',
                                priorite: '',
                            },
                            children: tmpValues
                        });
                    }

                    setRows(tmpRows);
                }
            });
    }, [nbModifs]);

    useEffect(() => {
        axios.get('/api/competences/get').then(response => {
            let tmpCompetences = response.data.map(x => { return { value: x } }
            );
            tmpCompetences.sort((x, y) => comparer(x.value, y.value));
            setCompetences(tmpCompetences)
        })
    }, []);

    const templateButton = x => {
        if (x.data.competence) {
            return <div><i className="pi pi-sync text-success me-3" onClick={() => {
                setActiviteToUpdate(x.data.activite);
                setCompetenceToUpdate(x.data.competence)

                updateFormik.setFieldValue('priorite', x.data.priorite)

                const modal = Modal.getOrCreateInstance(modalRefUpdate.current);
                modal.show();
            }}

            ></i>
                <i className="pi pi-times-circle text-danger" onClick={() => {
                    setToRemoveActivite(x.data.activite);
                    setToRemoveCompetence(x.data.competence);

                    setOpenConfirmRemoveModal(true);
                }} ></i></div>
        }
        else {
            return <div><i className="pi pi-plus text-success" onClick={() => {
                setActiviteToInsert(x.data.activite);
                insertFormik.resetForm();

                const modal = Modal.getOrCreateInstance(modalRefInsert.current);
                modal.show();

            }}></i></div>
        }
    }

    const removeCompetence = () => {
        axios.get('/api/competence' + controllerNaming + '/remove?competence=' + toRemoveCompetence + '&activite=' + toRemoveActivite).then(response => {
            if (response.status === 200) {

                display({
                    titre: `compétence ${textNaming} retiré`,
                    text: `la compétence ${textNaming} '${toRemoveCompetence}' a été retiré à l'activité' ${toRemoveActivite}`,
                    severity: 'success'
                });

                setNbModifs(nbModifs + 1);
            }
            else {
                display({
                    titre: `compétence ${textNaming} non retiré`,
                    text: `la compétence ${textNaming} '${toRemoveCompetence}' n'a pas pu être retiré à l'activité' ${toRemoveActivite}`,
                    severity: 'danger'
                })
            }
        });
    }

    return <div>
        <div className="alert alert-info">
            {infoDiv}
        </div>
        <div ref={modalRefInsert} className="modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Ajouter une compétence { textNaming }</h5>
                    </div>
                    <form onSubmit={insertFormik.handleSubmit}
                    >
                        <div className="modal-body"  >
                            <div className="alert alert-info">Vous allez ajouter une compétence {textNaming} à l'activité <b>{activiteToInsert}</b></div>
                            <div className="form-group">
                                <label htmlFor="competence">Compétence</label>
                                {/*<Dropdown onChange={insertFormik.handleChange}*/}
                                {/*    name="competence" value={insertFormik.values.competence} options={competences} optionLabel="value" optionValue="value" placeholder="Sélectionner une compétence"*/}
                                {/*    filter className={`form-control ${errorCss(insertFormik.errors.competence)}`} />*/}
                                {/*{insertFormik.errors.competence ? (*/}
                                {/*    <div className="invalid-feedback">{insertFormik.errors.competence}</div>*/}
                                {/*) : (<></>)}*/}
                                <input list="competences-list" className={`form-select ${errorCss(insertFormik.errors.competence)}` }   onChange={insertFormik.handleChange} value={insertFormik.values.competence} name="competence" />
                                <datalist id="competences-list">
                                    {competences.map(x => <option key={x.value} value={ x.value } />) }
                                </datalist>
                                {insertFormik.errors.competence ? (
                                    <div className="invalid-feedback">{insertFormik.errors.competence}</div>
                                ) : (<></>)}
                            </div>
                            <div className="form-group">
                                <label htmlFor="priorite">Priorité</label>
                                <input name="priorite" onChange={insertFormik.handleChange}
                                    value={insertFormik.values.priorite} type="text" id="priorite" className={`form-control ${errorCss(insertFormik.errors.priorite)}`}></input>
                                {insertFormik.errors.priorite ? (
                                    <div className="invalid-feedback">{insertFormik.errors.priorite}</div>
                                ) : (<></>)}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success"  >Valider</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div ref={modalRefUpdate} className="modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Modifier la propriété d'une compétence {textNaming}</h5>
                    </div>
                    <form onSubmit={updateFormik.handleSubmit}
                    >
                        <div className="modal-body"  >
                            <div className="alert alert-info">Vous allez modifier la priorié pour la compétence { textNaming } <b>{competenceToUpdate}</b> de l'activité <b>{activiteToUpdate}</b></div>

                            <div className="form-group">
                                <label htmlFor="priorite">Priorité</label>
                                <input name="priorite" onChange={updateFormik.handleChange}
                                    value={updateFormik.values.priorite} type="text" id="priorite" className={`form-control ${errorCss(updateFormik.errors.priorite)}`}></input>
                                {updateFormik.errors.priorite ? (
                                    <div className="invalid-feedback">{updateFormik.errors.priorite}</div>
                                ) : (<></>)}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success"  >Valider</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <TreeTable value={rows} sortMode="multiple" >

            <Column field="activite" sortable header="Activité" filter expander></Column>

            <Column field="competence" sortable header="Compétence" filter></Column>

            <Column field="priorite" sortable header="Priorite" filter></Column>
            <Column body={templateButton} />

        </TreeTable>
        <ConfirmModalComponent open={openConfirmRemoveModal} setOpen={setOpenConfirmRemoveModal} titre="êtes vous sure de supprimer ?" message={`Vous allez supprimer la competence '${toRemoveCompetence}' pour l'activité '${toRemoveActivite}' , êtes-vous sure ? `} onConfirm={removeCompetence} />
    </div>
}




